import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

import { BottomReachedTrigger } from 'presentation/common/spreeng-models';

export interface CoacheeProfileState {
	readonly bottomReachedTrigger: BottomReachedTrigger;
	readonly activeTabIndex: number;
	readonly coacheeId: string;
	readonly loading: boolean;
	readonly meetingChangedTrigger: number;
}

@Injectable()
export class CoacheeProfileStore extends Store<CoacheeProfileState> {
	constructor() {
		super(
			{ loading: true, activeTabIndex: 0 },
			{ name: `ui-coachee-profile-${guid()}` }
		);
	}
}
